import Routes from "@/common/router/Routes";
import ModelRouter from "@/context/model/router/ModelRouter";

export default class ModelRoutes extends Routes {
  private static _instance: ModelRoutes;
  public static instance(): ModelRoutes {
    if (!ModelRoutes._instance) {
      ModelRoutes._instance = new ModelRoutes();
    }
    return ModelRoutes._instance;
  }
  private constructor() {
    super({
      label: "Modele",
      router: ModelRouter.instance(),
      lazyPage: () => import("@/context/model/pages/ModelPage.vue"),
      lazyCreate: () => import("@/context/model/containers/ModelFormContainer.vue"),
      lazyUpdate: () => import("@/context/model/containers/ModelFormContainer.vue"),
      lazyList: () => import("@/context/model/containers/ModelListContainer.vue"),
      lazyShow: () => import("@/context/model/containers/ModelAdvancedShowContainer.vue")
    });
  }
}
